<template>
  <div>
    <loading-spinner :is-loading="isLoading" />
    <div class="main-content-container container-fluid px-4">
      <!-- Page Header -->
      <div class="page-header row no-gutters pt-4 pb-2">
        <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">Mes demandes</span>
        </div>
      </div>
      <div class="row flex pb-2">
        <div class="col-12">
          <h5 class="float-left font-weight-bold mb-0">
            Demande
            <span> de Contrat</span>

            | {{ request.lastName }} {{ request.firstName }}
          </h5>
          <div class="col-12 mt-5">
            <button
              class="btn btn-outline wizard-btn return-btn float-left"
              @click="backToList()"
            >
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
              {{ $t("global.return") }}
            </button>
            <button
              v-if="
                this.$store.state.user.informations.permissions[0]
                  .groupReference == '_super_admin'
              "
              class="btn btn-danger next-btn float-right mr-3"
              @click="deleteDemand()"
            >
              Supprimer
            </button>
            <button
              v-if="edit"
              class="btn btn-danger next-btn float-right mr-3 px-7"
              @click="cancelEditing()"
            >
              Annuler
            </button>
            <button
              v-if="
                this.$store.state.user.informations.permissions[0]
                  .groupReference == '_super_admin'
              "
              class="btn btn-warning next-btn float-right mr-3"
              @click="editDemand()"
            >
              {{ edit ? "Confirmer" : "Modifier" }}
            </button>
            <label
              for="uploadFinalDoc"
              v-if="
                request.answers[0].status == 'ACCEPTED' ||
                request.answers[0].status == 'TREATED'
              "
              class="float-right btn generate-upload-contract-button mr-3"
              ><i class="fa fa-upload mr-1" aria-hidden="true"></i>IMPORTER LE
              CONTRAT SIGNÉ</label
            >
            <input
              id="uploadFinalDoc"
              class="uploadFinalDoc"
              type="file"
              @change="UploadFinalContract"
            />
            <button
              v-if="
                this.$store.state.user.informations.permissions[0]
                  .groupReference == '_super_admin' ||
                (request.addInfoValid &&
                  (request.typeOfContract == 'CDI' ||
                    request.typeOfContract == 'CDD')) ||
                (request.typeOfContract == 'CEE' &&
                  (request.answers[0].status == 'ACCEPTED' ||
                    request.answers[0].status == 'TREATED'))
              "
              class="float-right btn generate-upload-contract-button mr-3"
              @click="generateContract()"
            >
              <i class="fa fa-download" aria-hidden="true"></i>
              GÉNÉRER LE CONTRAT
            </button>
          </div>
        </div>
      </div>
      <div class="mb-4 pb-5">
        <spinner-dot v-if="loading" />
        <template v-else>
          <div class="card mb-4">
            <div class="card-body p-4">
              <div
                v-if="request.status == 'ACCEPTED'"
                class="d-inline float-right"
              >
                <div
                  class="minibus-demand-positive-opnion d-flex align-items-center justify-content-center mr-5 mt-5"
                >
                  <svg
                    height="50"
                    width="50"
                    color="#FFFFFF"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                    <path
                      fill="#FFFFFF"
                      d="M0 64C0 28.65 28.65 0 64 0H224V128C224 145.7 238.3 160 256 160H384V198.6C310.1 219.5 256 287.4 256 368C256 427.1 285.1 479.3 329.7 511.3C326.6 511.7 323.3 512 320 512H64C28.65 512 0 483.3 0 448V64zM256 128V0L384 128H256zM576 368C576 447.5 511.5 512 432 512C352.5 512 288 447.5 288 368C288 288.5 352.5 224 432 224C511.5 224 576 288.5 576 368zM476.7 324.7L416 385.4L387.3 356.7C381.1 350.4 370.9 350.4 364.7 356.7C358.4 362.9 358.4 373.1 364.7 379.3L404.7 419.3C410.9 425.6 421.1 425.6 427.3 419.3L499.3 347.3C505.6 341.1 505.6 330.9 499.3 324.7C493.1 318.4 482.9 318.4 476.7 324.7H476.7z"
                    />
                  </svg>
                  <span>APPROUVÉ PAR LE DIRECTEUR</span>
                </div>
              </div>
              <div class="row py-5 px-5">
                <template class="my-5">
                  <recapitulatif-contract-request
                    :request="request"
                    :edit="edit"
                    :allStructures="allStructures"
                    :show-last-two="false"
                  />
                </template>
                <div class="col-12">
                  <div class="row">
                    <button
                      class="download-document-button"
                      @click="downloafUpload(request.IDPath)"
                    >
                      <i class="fa fa-paperclip fa-lg" aria-hidden="true"></i
                      ><span class="ml-2">Pièce d'identité</span>
                    </button>
                    <button
                      class="download-document-button"
                      @click="downloafUpload(request.CVPath)"
                    >
                      <i class="fa fa-paperclip fa-lg" aria-hidden="true"></i
                      ><span class="ml-2">Carte vitale</span>
                    </button>
                    <button
                      v-for="otherDoc in request.otherDocumentsPaths"
                      class="download-document-button"
                      @click="downloafUpload(otherDoc.path)"
                    >
                      <i class="fa fa-paperclip fa-lg" aria-hidden="true"></i
                      ><span class="ml-2">{{ otherDoc.name }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer light-bg">
              <div>
                <div
                  class="row flex align-items-center"
                  v-if="
                    (!answered && listOfSupervisor.includes(user.reference)) ||
                    edit
                  "
                >
                  <div class="col-lg-4">
                    <p class="m-0">
                      {{ $t("global.ask.approval.disapproval") }}
                    </p>
                  </div>
                  <div class="col-lg-4">
                    <div
                      class="custom-control custom-radio custom-control-inline"
                    >
                      <input
                        class="custom-control-input"
                        @click="answer = true"
                        type="radio"
                        v-model="answer"
                        id="approve"
                        :value="true"
                      />
                      <label class="custom-control-label" for="approve">
                        {{ $t("global.approve") }}
                      </label>
                    </div>
                    <div
                      class="custom-control custom-radio custom-control-inline"
                    >
                      <input
                        class="custom-control-input"
                        @click="answer = false"
                        type="radio"
                        v-model="answer"
                        id="disapprove"
                        :value="false"
                      />
                      <label class="custom-control-label" for="disapprove">
                        {{ $t("global.disapprove") }}
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <button
                      v-if="
                        !answered && listOfSupervisor.includes(user.reference)
                      "
                      class="btn btn-primary wizard-btn next-btn float-right"
                      @click="confirmRequest()"
                    >
                      {{ $t("global.submit") }}
                    </button>
                  </div>
                  <div class="col-lg-7 pt-2" v-if="!answer">
                    <div class="form-group">
                      <textarea
                        class="form-control"
                        v-model="motif"
                        :placeholder="$t('global.explain.reason.disapproval')"
                        cols="50"
                        rows="10"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between"
                  v-else-if="
                    user.permissions[0].groupReference == '_super_admin' &&
                    !request.addInfoValid &&
                    (request.typeOfContract == 'CDI' ||
                      request.typeOfContract == 'CDD')
                  "
                >
                  <div>
                    <h6>
                      Veuillez renseigner les champs nécessaires à la génération
                      du contrat.
                    </h6>
                  </div>
                  <div>
                    <button
                      class="btn btn-primary wizard-btn next-btn mr-3"
                      @click="showAdditional"
                    >
                      RENSEIGNER LES INFORMATIONS
                    </button>
                  </div>
                </div>
                <div v-else>
                  <h6>{{ $t("days.off.request.already.answered") }}</h6>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="header-data-table flex">
                  <div>
                    <h5 class="header-data-table__heading">
                      Contrats importés
                    </h5>
                  </div>
                  <div class="ml-auto mr-5">
                    <button
                      v-if="
                        this.$store.state.user.informations.permissions[0]
                          .groupReference == '_super_admin' &&
                        request.status != 'TREATED' &&
                        request.importedDocuments.length != 0
                      "
                      class="float-right btn generate-upload-contract-button mr-3"
                      @click="allUserSinged()"
                    >
                      <i class="fa fa-pencil-alt" aria-hidden="true"></i>
                      CONTRAT SIGNÉ PAR TOUTES LES PARTIES
                    </button>
                  </div>
                </div>
                <div class="table-responsive pb-3">
                  <table class="custom-table table t-responsive">
                    <thead class="t-header-color">
                      <tr class="text-center">
                        <th>Nom</th>
                        <th>Renseigné</th>
                        <th>Fichier</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(answer, idx) in request.importedDocuments"
                        :key="idx"
                      >
                        <template>
                          <td>{{ answer.nom }}</td>
                        </template>
                        <td>
                          {{
                            answer.date
                              ? new Date(answer.date).toLocaleDateString(
                                  "fr-FR"
                                ) +
                                " (" +
                                new Date(answer.date).toLocaleTimeString(
                                  "fr-FR"
                                ) +
                                ")"
                              : ""
                          }}
                        </td>
                        <td>
                          <button
                            class="contract-answer-fichier"
                            @click="downloadFichier(answer.fichier)"
                          >
                            {{ answer.fichier }}
                          </button>
                        </td>
                      </tr>
                      <tr v-if="request.importedDocuments.length == 0">
                        <td></td>
                        <td><h5>Non renseigné</h5></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="header-data-table">
                  <h5 class="header-data-table__heading">
                    Statut de la demande
                  </h5>
                </div>
                <div class="table-responsive pb-3">
                  <table class="custom-table table t-responsive">
                    <thead class="t-header-color">
                      <tr class="text-center">
                        <th>Suivi</th>
                        <th>Nom</th>
                        <th>Statut</th>
                        <th>Date</th>
                        <th>Commentaires</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(answer, idx) in request.answers" :key="idx">
                        <template
                          v-if="answer.groupReference === GroupsEnum.IN_CHARGE"
                        >
                          <td>N+{{ answer.position }}</td>
                        </template>
                        <template
                          v-if="
                            answer.groupReference === GroupsEnum.SUPER_ADMIN
                          "
                        >
                          <td>Direction</td>
                        </template>
                        <template
                          v-if="answer.groupReference === GroupsEnum.COMPTA"
                        >
                          <td>Comptable</td>
                        </template>
                        <td>{{ answer.name }}</td>
                        <td v-if="answer.status === 'ACCEPTED'">
                          <button class="status-pill-accepted">
                            <span>{{ $t("global.approved") }}</span>
                          </button>
                        </td>
                        <td v-else-if="answer.status === 'PENDING'">
                          <button class="status-pill-pending">
                            <span>{{ $t("global.pending") }}</span>
                          </button>
                        </td>
                        <td v-else-if="answer.status === 'REFUSED'">
                          <button class="status-pill-rejected">
                            <span>{{ $t("global.rejected") }}</span>
                          </button>
                        </td>
                        <td v-else-if="answer.status === 'TREATED'">
                          <button class="status-pill-approved">
                            <span>Contrat traité</span>
                          </button>
                        </td>
                        <td>
                          {{
                            answer.date
                              ? new Date(answer.date).toLocaleDateString(
                                  "fr-FR"
                                ) +
                                " (" +
                                new Date(answer.date).toLocaleTimeString(
                                  "fr-FR"
                                ) +
                                ")"
                              : ""
                          }}
                        </td>
                        <!-- <td>{{ answer.motif ? answer.motif : "" }}</td> -->
                        <td v-if="answer.motif">
                          <button
                            class="HistoryDemands-refuseButton"
                            @click="showReason(answer.motif)"
                          >
                            <i class="fa fa-eye" aria-hidden="true"></i>
                          </button>
                        </td>
                        <td v-else></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <simple-modal ref="reasonModal" :motif="selectedMotif" />
    <additional-information-vue
      ref="additionInformationModel"
      :reference="reff"
    />
  </div>
</template>

<script>
import SpinnerDot from "../../components/layout/Loading/spinner-dot";
import RecapitulatifContractRequest from "../../components/contract/RecapitulatifContractRequest.vue";
import { storage } from "../../firebase/app";
import {
  ref,
  uploadBytes,
  uploadBytesResumable,
  getDownloadURL,
  getBlob,
} from "firebase/storage";
import GroupsEnum from "../../data/groups/GroupsEnum";
import SimpleModal from "../../components/abscenceRequest/SimpleModal.vue";
import additionalInformationVue from "../../components/contract/additionalInformation.vue";
import loadingSpinner from "../../components/shared/loadingSpinner.vue";

export default {
  name: "contract-answer",
  components: {
    SimpleModal,
    SpinnerDot,
    RecapitulatifContractRequest,
    additionalInformationVue,
    loadingSpinner,
  },
  mounted() {
    this.reff = this.$route.params.reference;
    // console.log(this.$route.params.reference);
    // console.warn("USer : ", this.listOfSupervisor.includes(this.user.reference) );
    this.$services.contractRequestService
      .findByReference(this.$route.params.reference)
      .then(({ data }) => {
        this.request = data;
        this.request.answers.forEach((answer) =>
          this.listOfSupervisor.push(answer.userReference)
        );
        this.originalRequest = JSON.parse(JSON.stringify(data));
        // console.warn("data : ", data);
        // console.log(
        //   "check : ",
        //   this.request.authorized.indexOf(this.user.reference) === -1
        // );
        if (this.request.authorized.indexOf(this.user.reference) === -1) {
          console.log("premission denied");
          this.$router.push("/permission-denied");
        }
        this.alreadyAnswered();
        this.loading = false;
      });
  },
  data() {
    return {
      loading: true,
      isLoading: false,
      request: null,
      answer: true,
      answered: false,
      motif: "",
      GroupsEnum,
      selectedMotif: "",
      originalRequest: null,
      edit: false,
      allStructures: null,
      reff: "",
      listOfSupervisor: [],
      groupNames: {
        _super_admin: "Direction",
        _admin: "Administrateur",
        _compta: "Comptable",
        _in_charge: "N+1",
        _animateur: "Animateur",
        _receptionist: "Réceptionniste",
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user.informations;
    },
  },
  methods: {
    downloafUpload(filePath) {
      getDownloadURL(ref(storage, filePath))
        .then((url) => {
          let path = filePath;
          const xhr = new XMLHttpRequest();
          xhr.responseType = "blob";
          xhr.open("GET", url);
          xhr.send();
          xhr.onload = function () {
            const blob = new Blob([xhr.response]);
            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = path;
            a.click();
          };
        })
        .catch((error) => {
          console.error(error);
        });
    },
    downloadMultipleFiles(pathArray) {
      pathArray.forEach((filePath) => {
        if (filePath.path) {
          getDownloadURL(ref(storage, filePath.path))
            .then((url) => {
              let path = filePath.path;
              const xhr = new XMLHttpRequest();
              xhr.responseType = "blob";
              xhr.open("GET", url);
              xhr.send();
              xhr.onload = function () {
                const blob = new Blob([xhr.response]);
                const a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = path;
                a.click();
              };
            })
            .catch((error) => {
              console.error(error);
            });
        }
      });
    },
    alreadyAnswered() {
      const a = this.request.answers.find(
        (answer) => answer.userReference === this.user.reference
      );
      if (a) {
        if (a.status !== "PENDING") {
          this.answered = true;
        }
      } else {
        this.answered = false;
      }
    },
    confirmRequest() {
      this.loading = true;
      const model = {
        status: this.answer ? "ACCEPTED" : "REFUSED",
        userReference: this.user.reference,
        motif: this.motif,
      };
      // console.log("model : ", model);
      this.$services.contractRequestService
        .confirmRequest(this.request.reference, model)
        .then(({ data }) => {
          this.request = data;
          this.alreadyAnswered();
          this.loading = false;
          this.$miniToastr.success("Votre réponse a bien été enregistrée.");
        })
        .catch(() => (this.loading = false));
    },
    showReason(reason) {
      // console.log(reason);
      this.selectedMotif = reason;
      this.$refs.reasonModal.openModal();
    },
    showAdditional() {
      this.$refs.additionInformationModel.openModal();
    },
    backToList() {
      this.$router.go(-1);
    },
    async deleteDemand() {
      await this.$services.contractRequestService
        .deleteRequest(this.request.reference)
        .then((res) => {
          this.$router.push(`/gestionnaire/contracts`);
          this.$miniToastr.success("Demande supprimée avec succès");
        })
        .catch((e) => {
          this.$miniToastr.error(
            "Il y a eu une erreur lors de l'supprimée du demande"
          );
        });
    },
    async cancelEditing() {
      this.edit = false;
      this.request = JSON.parse(JSON.stringify(this.originalRequest));
    },
    async editDemand() {
      if (this.edit) {
        this.request.answers[0].status = this.answer ? "ACCEPTED" : "REFUSED";
        this.request.status = this.answer ? "ACCEPTED" : "REFUSED";
        this.request.answers[0].date = new Date();
        if (this.motif) {
          this.request.refuseReason = this.motif;
          this.request.answers[0].motif = this.motif;
        }
        // console.log(this.request);
        await this.$services.contractRequestService
          .editRequest(this.request.reference, this.request)
          .then((res) => {
            // this.$router.push(`/gestionnaire/contracts`);
            this.$miniToastr.success("Demande éditer avec succès");
          })
          .catch((e) => {
            this.$miniToastr.error(
              "Il y a eu une erreur lors de l'éditer du demande"
            );
          });
      }
      this.edit = !this.edit;
      if (this.edit) {
        this.$services.structure.findAll().then((response) => {
          this.allStructures = response.data;
        });
      }
    },
    async generateContract() {
      this.isLoading = true;
      this.$services.contractRequestService
        .generateContract(this.request.reference)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Contrat_${this.request.lastName}_${this.request.firstName}.docx`
          ); // Replace with the name of the file to download
          document.body.appendChild(link);
          link.click();
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async allUserSinged() {
      this.isLoading = true;
      this.request.status = "TREATED";
      this.request.answers[0].status = "TREATED";
      this.$services.contractRequestService
        .editRequest(this.request.reference, this.request)
        .then(() => {
          this.isLoading = false;
        });
    },
    async UploadFinalContract() {
      this.isLoading = true;
      const storageRef = ref(
        storage,
        `${this.request.reference}/${event.target.files[0].name}`
      );
      this.uploadTask = uploadBytesResumable(storageRef, event.target.files[0]);
      let fileName = event.target.files[0].name;
      this.uploadTask.on(
        "state_changed",
        (snapshot) => {},
        (error) => {},
        () => {
          getDownloadURL(this.uploadTask.snapshot.ref).then((downloadURL) => {
            // console.log("File available at", downloadURL);
            this.request.ContractPath = downloadURL;
            // this.request.status = "TREATED";
            // this.request.answers[0].status = "TREATED";
            if (this.request.importedDocuments) {
              this.request.importedDocuments.push({
                nom: `${this.user.firstName} ${this.user.lastName}`,
                date: new Date(),
                fichier: fileName,
                suivi: this.groupNames[this.user.permissions[0].groupReference],
              });
            } else {
              this.request.importedDocuments = [
                {
                  nom: `${this.user.firstName} ${this.user.lastName}`,
                  date: new Date(),
                  fichier: fileName,
                  suivi:
                    this.groupNames[this.user.permissions[0].groupReference],
                },
              ];
            }
            this.$services.contractRequestService
              .editRequest(this.request.reference, this.request)
              .then(() => {
                this.isLoading = false;
                location.reload();
              });
          });
        }
      );
    },
    downloadFichier(fichier) {
      const storageRef = ref(storage, `${this.request.reference}/${fichier}`);
      getDownloadURL(storageRef)
        .then((url) => {
          window.open(url, "_blank");
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
.HistoryDemands-refuseButton {
  border: 1px #abb6bf solid;
  border-radius: 5px;
  color: #abb6bf;
  padding: 5px 10px;
}

.generate-upload-contract-button {
  background-color: white !important;
  border: 1px solid #4f78e2;
  color: #4f78e2;
}

.uploadFinalDoc {
  /* opacity:0 ; */
  display: none;
}

.contract-answer-fichier {
  text-decoration: underline;
}
</style>
